import { FC, useMemo } from "react";
import { useLocation } from "react-router";

import Loading from "web/Layout/Common/Loading";
import LoadMore from "web/Layout/LoadMore";
import { CUSTOMER_CONTENT_ID } from "web/Layout/Main/const";
import __ from "web/Layout/Translations";

import Title from "web/Components/Common/Title";
import withScrollToTop from "web/Components/Common/withScrollToTop/withScrollToTop";

import { ICodeItem } from "web/types/Code";

import { FilterValues } from "web/features/codes/utils/helpers";

import List from "../Shared/List";
import Filters from "./Filters";
import classes from "./codeList.scss";

interface ICustomerCodeListDesktopProps {
  className: string;
  codes: ICodeItem[];
  isLoading: boolean;
  title: string;
  toUseCount: number;
  usedCount: number;
  canceledCount: number;
  totalCount: number;
}

const titleClasses = {
  root: classes.header,
  header: classes.title,
};
const name = "availability";

const titleId = "code-list-title";

const CustomerCodeListDesktop: FC<ICustomerCodeListDesktopProps> = ({
  className,
  codes,
  isLoading,
  title,
  toUseCount,
  usedCount,
  canceledCount,
  totalCount,
}) => {
  const { search } = useLocation();
  const params = new URLSearchParams(decodeURIComponent(search));
  const filters = useMemo(() => {
    return [
      {
        label: `${__("Wszystkie")} (${totalCount})`,
        value: FilterValues.ALL,
        count: totalCount,
      },
      {
        label: `${__("Do wykorzystania")} (${toUseCount})`,
        value: FilterValues.USE,
        count: toUseCount,
      },
      {
        label: `${__("Wykorzystane")} (${usedCount})`,
        value: FilterValues.USED,
        count: usedCount,
      },
      {
        label: `${__("Anulowane")} (${canceledCount})`,
        value: FilterValues.CANCELED,
        count: canceledCount,
      },
    ];
  }, [toUseCount, usedCount, canceledCount, totalCount]);
  const type = params.get(name) || FilterValues.ALL;

  const currentTotal = codes?.length;
  const filterTotalCount =
    filters.find((filter) => filter.value === type)?.count || 0;
  return (
    <section
      className={className}
      id={CUSTOMER_CONTENT_ID}
      aria-labelledby={titleId}
    >
      <Title
        name={title}
        count={totalCount}
        classes={titleClasses}
        dataT1="code_list_title"
        ariaLabelBadge={__("Liczba kodów")}
        id={titleId}
      />
      <Filters name={name} filters={filters} type={type} />
      <h2 className="visually-hidden">{__("Lista kodów")}</h2>
      <List codes={codes} />
      {isLoading ? <Loading className={classes.loading} /> : null}
      {!!currentTotal && filterTotalCount > currentTotal && (
        <div className={classes.loadMoreContainer}>
          <LoadMore
            total={filterTotalCount}
            currentTotal={currentTotal}
            shouldChangePage
            loading={isLoading}
          />
        </div>
      )}
    </section>
  );
};

export default withScrollToTop(CustomerCodeListDesktop);
